import { render, staticRenderFns } from "./author.vue?vue&type=template&id=080e379b&scoped=true"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.vue?vue&type=style&index=0&id=080e379b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e379b",
  null
  
)

export default component.exports